import { Fragment, useState } from 'react';

import Button, { ButtonIconPosition, ButtonKind, ButtonScale } from 'bloko/blocks/button';
import Icon, { IconAppearance, IconColor, IconKind, IconScale, IconView } from 'bloko/blocks/icon';

import useTrls from 'hooks/translation/useTrls';

import ClickmeButtonsWrapper from 'components/ClickmeButtonsWrapper';
import ClickmeFormWrapper from 'components/ClickmeFormWrapper';

import makePayer from 'components/Admin/PayerCreate/PayerCreateForm/makePayer';
import PayerINN from 'components/Admin/PayerCreate/PayerCreateForm/PayerINN';
import PayerKPP from 'components/Admin/PayerCreate/PayerCreateForm/PayerKPP';
import PayerLegalAddress from 'components/Admin/PayerCreate/PayerCreateForm/PayerLegalAddress';
import PayerLegalDocAddress from 'components/Admin/PayerCreate/PayerCreateForm/PayerLegalDocAddress';
import PayerLegalName from 'components/Admin/PayerCreate/PayerCreateForm/PayerLegalName';
import PayerName from 'components/Admin/PayerCreate/PayerCreateForm/PayerName';
import PayerType from 'components/Admin/PayerCreate/PayerCreateForm/PayerType';

import { InvoicePayerType } from 'store/models/invoices';
import { useDispatch, useSelector } from 'store/utils';

export const PayerCreateForm = () => {
    const dispatch = useDispatch();
    const [isLoad, setLoad] = useState(false);
    const payerType = useSelector((state) => state.payerCreate.payerType);
    const trl = useTrls();

    return (
        <Fragment>
            <ClickmeFormWrapper>
                <PayerType />
                {[InvoicePayerType.Legal, InvoicePayerType.Individual].includes(payerType) && (
                    <Fragment>
                        <PayerLegalName />
                        <PayerINN />
                        {payerType === InvoicePayerType.Legal && <PayerKPP />}
                        <PayerLegalAddress />
                        <PayerLegalDocAddress />
                    </Fragment>
                )}
                {payerType === InvoicePayerType.Natural && <PayerName />}
            </ClickmeFormWrapper>
            <ClickmeButtonsWrapper>
                <Button
                    kind={ButtonKind.Success}
                    scale={ButtonScale.Large}
                    icon={
                        <Icon
                            view={IconView.Checkmark}
                            initial={IconColor.White}
                            kind={IconKind.Single}
                            appearance={IconAppearance.Outlined}
                            scale={IconScale.Medium}
                        />
                    }
                    iconPosition={ButtonIconPosition.Right}
                    disabled={isLoad}
                    onClick={() => dispatch(makePayer(setLoad))}
                    data-qa="payer-create"
                >
                    {trl('InvoiceAndPayerForm.PayerCreate.save')}
                </Button>
            </ClickmeButtonsWrapper>
        </Fragment>
    );
};
